import {useCallback, useMemo} from 'react';

import {Session} from 'nutshell-core/session';

import {EditableLabelField} from '../../../../core-entity/widgets/summary-widget/editable-label-field';

interface Props {
    revenue: number | null | undefined;
    onUpdateAccountRevenue: (revenue: number) => Promise<any>;
}

export function AccountRevenueField(props: Props) {
    const {revenue, onUpdateAccountRevenue} = props;
    const currencyCode = Session.getInstanceDefaultCurrencyCode();

    const formattedRevenue = useMemo(() => {
        if (revenue == null) {
            return '';
        }

        return revenue.toLocaleString(undefined, {
            style: 'currency',
            currency: currencyCode,
        });
    }, [revenue, currencyCode]);

    const editableRevenueValue = useMemo(() => {
        if (revenue == null) {
            return '';
        }

        return String(revenue);
    }, [revenue]);

    const handleSaveRevenue = useCallback(
        (newValue: string) => {
            const normalizedValue = newValue.replace(/[^0-9.-]/g, '');
            const parsedRevenue = Number(normalizedValue);

            if (
                !normalizedValue.length ||
                normalizedValue === '.' ||
                normalizedValue === '-' ||
                Number.isNaN(parsedRevenue)
            ) {
                return Promise.reject(new Error('Invalid revenue value'));
            }

            return onUpdateAccountRevenue(parsedRevenue);
        },
        [onUpdateAccountRevenue]
    );

    return (
        <EditableLabelField
            label='Revenue'
            value={formattedRevenue}
            editValue={editableRevenueValue}
            onSaveNewValue={handleSaveRevenue}
            placeholder={`${currencyCode} 0.00`}
            tooltip={formattedRevenue || `${currencyCode} 0.00`}
        />
    );
}
